import translation from "./translation";

const en = {
  translation,
};

export default en;
